'use strict';

function HeaderHero() {
  this.name = 'header-hero'; //internal page

  $(".header-hero-text").wrap('<div class="header-hero-text-outer"></div>'); //don't need this on main homepage

  $(".aciar-colab-main-site .header-hero-text").unwrap();
  $(".aciar-colab-main-site").removeClass("path-frontpage"); //add move down arrow

  $(".aciar-colab-main-site .header-hero-text").append('<div class="move-down"></div><div class="explore-description">explore</div>');
  $('.move-down').click(function () {
    window.scroll({
      top: 650,
      left: 0,
      behavior: 'smooth'
    });
  });
  if ($('.header-hero .text-formatted').text() == '') {
    $('.page-node-type-standard-page #header-hero .header-hero-text').hide();
  }
  ;
};
export default HeaderHero;
